import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const ServiceCard = ({
  service,
  onServiceClick,
  onComparisonToggle,
  isInComparison,
  comparisonDisabled
}) => {

  const navigate = useNavigate();

  return (
    <div className="bg-surface rounded-lg card-shadow hover:card-shadow-lg nav-transition p-8 group">
      <div className="flex items-start justify-between mb-6">
        <div className="w-16 h-16 bg-primary-50 rounded-lg flex items-center justify-center group-hover:bg-primary group-hover:text-white nav-transition">
          <Icon name={service.icon} size={32} />
        </div>

        <div className="flex space-x-2">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onComparisonToggle(service.id);
            }}
            disabled={comparisonDisabled}
            className={`px-3 py-2 rounded-md text-sm font-medium nav-transition ${
              isInComparison
                ? 'bg-primary text-white'
                : comparisonDisabled
                ? 'bg-secondary-100 text-secondary-400 cursor-not-allowed'
                : 'bg-secondary-100 text-secondary-600 hover:bg-[#1e40af] hover:text-white'
            }`}
            title={isInComparison ? 'Uncompare from comparison' : 'Add to comparison'}
          >
            {isInComparison ? 'Uncompare' : 'Compare'}
          </button>
        </div>
      </div>

      <div onClick={() => onServiceClick(service)}>
        <h3 className="text-2xl font-heading font-semibold text-text-primary mb-4 group-hover:text-primary nav-transition">
          {service.title}
        </h3>

        <p className="text-text-secondary mb-6 leading-relaxed">
          {service.description}
        </p>

        <div className="mb-6">
          <h4 className="text-sm font-semibold text-text-primary mb-3">Key Benefits</h4>
          <div className="grid grid-cols-2 gap-2">
            {service.benefits.map((benefit, index) => (
              <div key={index} className="flex items-center space-x-2">
                <Icon name="Check" size={16} color="var(--color-success)" />
                <span className="text-sm text-text-secondary">{benefit}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <h4 className="text-sm font-semibold text-text-primary mb-3">Technologies</h4>
          <div className="flex flex-wrap gap-2">
            {service.technologies.map((tech, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-sm"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <span className="text-sm text-text-secondary">Starting from</span>
            <div className="text-lg font-semibold text-primary">
              {service.pricing.basic}
            </div>
          </div>

          <div className="flex items-center space-x-3 text-primary nav-transition">
            <button
              className="px-4 py-2 bg-primary text-white rounded-md text-sm hover:bg-primary-dark nav-transition"
              onClick={(e) => {
                e.stopPropagation();
                navigate('/contact');
              }}
            >
              Get Quote
            </button>

            <div className="flex items-center space-x-1 group-hover:translate-x-1 nav-transition">
              <span className="text-sm font-medium">Learn More</span>
              <Icon name="ArrowRight" size={16} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
